<template>
	<div class="activity-layout">
		<div class="layout-column layout-column--left">
			<div class="badge">
				<slot name="badge"></slot>
			</div>
			<div class="trail">
				<div :class="pathClasses"></div>
			</div>
		</div>
		<div class="layout-column layout-column--right">
			<div class="text">
				<slot name="text"></slot>
			</div>
			<div class="timestamp">
				<slot name="timestamp"></slot>
			</div>
			<div v-if="$slots.content">
				<slot name="content"></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ActivityLayout",
	emits: [ "action", ],
	props: {
		showPath: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		pathClasses() {
			return {
				path: true,
				"path--visible": this.showPath,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
$activityTextColor: $color1-500;
$activityBorderColor: $color1-200;

.activity-layout {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: stretch;
	gap: 1rem;

	@include anchor() {
		color: $anchorColor !important;
		font-weight: 600;
		text-decoration: none;
	}
}

.layout-column {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
}

.layout-column--right {
	flex: 1;

	// NOTE: this controls the spacing BETWEEN entries
	padding: 0.2rem 0 1rem 0;
}

.trail {
	flex: 1;
}

.path {
	width: 50%;
	height: 100%;
}

.path--visible {
	border-right: solid 0.0625rem $activityBorderColor;
}

.text {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;

	text-align: left;

	@include font-and-line-for(0);
	font-weight: 450;
	color: $activityTextColor;
}

.timestamp {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;

	@include font-and-line-for(-2);
	font-weight: 450;
	color: $activityTextColor;
}
</style>
